//
export const LangComJa = {
  pageBack: '戻る',
  pageNext: '進む',
  back: '戻る',
  close: '閉じる',
  send: '送信',
  langtoggle: 'English',
};
